<template>
  <div id="11_main">
    <v-row>
      <v-alert v-show="errorAlertShow" dense outlined type="error"><strong>Критична помилка! </strong>( {{errorMessage}} )</v-alert>
      <v-progress-linear v-show="progresLineShow" indeterminate fixed color="red"></v-progress-linear>
    </v-row>
    <div
      class="d-flex justify-space-around flex-wrap"

    >

      <v-card
        v-for="verstat in vetrstatsList"
        :key="verstat.id"
        class="mt-2"
        max-width="344"
        color="#4DB6AC"
       
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="headline">{{ verstat.nameverstat }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-img
          src="img/verstats/kugler.jpg"
          height="200px"
        >
        </v-img>
        <v-card-text>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="dialogUsersOpen(verstat)">
            <v-icon>mdi-account-details</v-icon>
          </v-btn>
        </v-card-actions>
      
      </v-card>

    </div>

    <v-dialog v-model="dialogUsers" scrollable persistent max-width="300px" @click:outside="dialogUsersClose()">
      <v-card>
        <v-card-title>{{dialogUsersVerstat.nameverstat}}</v-card-title>
        <v-card-subtitle>Мають доступ до верстата:</v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text style="height: 400px;">

          <v-checkbox
            v-for="user in dialogUserListOwner"
            :key="user.id"
            v-model="dialogOwnerSelected" 
            :label="user.pip" 
            :value="user.id">
            
          </v-checkbox>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="dialogUsersClose()">Close</v-btn>
          <v-btn color="blue darken-1" text @click="dialogUsersSave()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        errorMessage: '',
        errorAlertShow: false,
        progresLineShow: false,
        vetrstatsList: [],
        dialogUsers: false,
        dialogUsersVerstat: [],
        dialogUserListOwner: [],
        dialogOwnerSelected: [],

      }
    },
    methods: {
      getVerstatList () {
        this.progresLineShow = true;
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '11',
            ww: '1',
            pp: localStorage.pp,
            pn: localStorage.pn,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then(async response => {
          const data = await response.json();
          if (!response.ok) {
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }
          if (data.isauth == true) {
            this.vetrstatsList = data.vetrstatsList;
            this.progresLineShow = false;
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          this.errorMessage = error;
          this.progresLineShow = false;
          this.errorAlertShow = true;
          console.error('Error!', error);
        });
      },
      dialogUsersOpen (verstat) {
        this.dialogUsers = true
        this.dialogUsersVerstat = verstat
        this.progresLineShow = true;
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '11',
            ww: '2',
            pp: localStorage.pp,
            pn: localStorage.pn,
            verstat: verstat.id,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then(async response => {
          const data = await response.json();
          if (!response.ok) {
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }
          if (data.isauth == true) {
            this.dialogUserListOwner = data.userListOwner;
            this.dialogOwnerSelected = data.userListOwnwrVerstat;
            this.progresLineShow = false;
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          this.errorMessage = error;
          this.progresLineShow = false;
          this.errorAlertShow = true;
          console.error('Error!', error);
        });

      },
      dialogUsersClose () {
        this.dialogUsers = false
        this.dialogUsersVerstat = []
        this.dialogUserListOwner =[]
        this.dialogOwnerSelected = []

      },
      dialogUsersSave () {
        this.progresLineShow = true;
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '11',
            ww: '3',
            pp: localStorage.pp,
            pn: localStorage.pn,
            ownerSelected: this.dialogOwnerSelected,
            verstat: this.dialogUsersVerstat.id,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then(async response => {
          const data = await response.json();
          if (!response.ok) {
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }
          if (data.isauth == true) {
            this.progresLineShow = false
            this.dialogUsers = false
            this.dialogUsersVerstat = []
            this.dialogUserListOwner = []
            this.dialogOwnerSelected = []
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          this.errorMessage = error;
          this.progresLineShow = false;
          this.errorAlertShow = true;
          console.error('Error!', error);
        });
      },

    },
    created: function () {
      this.getVerstatList()
    },
  }
</script>